import React, { useEffect } from "react"

function Vimeo({
  src,
  controls = [
    "play-large",
    "play",
    "progress",
    "current-time",
    "mute",
    "volume",
    "captions",
    "settings",
    "pip",
    "airplay",
    "fullscreen",
  ],
}) {
  useEffect(() => {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      const Plyr = require("plyr")
      Array.from(document.querySelectorAll(".js-player")).map(
        (p) => new Plyr(p)
      )
    }
  }, [controls])

  return (
    <div
      className="js-player"
      data-plyr-provider="vimeo"
      data-plyr-embed-id={src}
      data-plyr-config={JSON.stringify({ controls })}
    />
  )
}

export default Vimeo
